import { jsxs as a, jsx as l } from "react/jsx-runtime";
import { E as f, S as _ } from "./icons.types-0722eef5.js";
function v({ title: s, titleId: c, size: e, width: h, height: n, extended: r = !1, ...o }) {
  const i = r ? f : _, d = e ? i[e] : h || i[r ? "s" : "l"], t = e ? i[e] : n || i[r ? "s" : "l"];
  return /* @__PURE__ */ a(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: d,
      height: t,
      "aria-labelledby": c,
      ...o,
      children: [
        s ? /* @__PURE__ */ l("title", { id: c, children: s }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Refresh__Filled_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M36 1.5c19.054 0 34.5 15.446 34.5 34.5 0 19.054-15.446 34.5-34.5 34.5C16.946 70.5 1.5 55.054 1.5 36 1.5 16.946 16.946 1.5 36 1.5Zm.002 11.85c-1.282 0-2.58.125-3.943.364l-.688.121-1.448 5.717 2.834-.644a16.82 16.82 0 0 1 3.245-.321c9.611 0 17.405 7.792 17.405 17.404 0 4.307-1.577 8.36-4.368 11.508l-3.811-3.81-3.96 15.374 15.308-4.024-3.84-3.84c3.782-4.154 5.905-9.514 5.905-15.208 0-12.504-10.135-22.64-22.639-22.64Zm-5.356-.422-15.223 3.964 3.868 3.864c-3.798 4.16-5.932 9.53-5.932 15.234 0 12.505 10.136 22.64 22.642 22.64 1.258 0 2.534-.12 3.864-.35l.686-.12 1.465-5.709-2.819.633c-1.047.203-2.121.31-3.196.31-9.613 0-17.405-7.791-17.405-17.404 0-4.32 1.588-8.385 4.395-11.538l3.788 3.788 3.867-15.312Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Refresh__Filled_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  v as RefreshFilled
};
